<mat-chip-option selectable="false">
  {{ label }}
  <i class="far fa-times ms-2 clickable" (click)="removeItem()"></i>
</mat-chip-option>
